import React from "react";

export default class SuccessBtnDemolition extends React.Component  
{

    render()
    {
        
        return (
            <div class="block services successtories mb-5">               
                <div className="card">
                    <h3>Success Stories</h3>    
                    <div>
                        <div className="text">"Hometown's quality leads and their excellent customer service have been a blessing..."</div>
                        <div className="author"><span>{'>>'}</span>Cindy Clore, Debuck Construction</div>
                    </div>
                    <a className="btn btn-primary" href="/pro/guide/tags/success-stories">See Success Stories</a>                          
                </div>
            </div>
        )
    }
};